import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Show banner after a short delay for better UX
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAcceptAll = () => {
        localStorage.setItem('cookieConsent', 'all');
        setIsVisible(false);
        // Here you would initialize analytics scripts
    };

    const handleAcceptNecessary = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
                >
                    <div className="max-w-7xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 p-6 md:flex items-center justify-between gap-6">
                        <div className="flex items-start gap-4 mb-4 md:mb-0">
                            <div className="p-3 bg-purple-100 rounded-xl shrink-0">
                                <Cookie className="w-6 h-6 text-purple-600" />
                            </div>
                            <div>
                                <h3 className="font-bold text-slate-900 mb-1">Vi värnar om din integritet</h3>
                                <p className="text-sm text-slate-600 leading-relaxed max-w-2xl">
                                    Vi använder cookies för att förbättra din upplevelse, analysera trafik och säkerställa att tjänsten fungerar korrekt.
                                    Genom att klicka på "Acceptera alla" godkänner du användningen av alla cookies.
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
                            <button
                                onClick={handleAcceptNecessary}
                                className="px-6 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50 rounded-xl border border-slate-200 transition-colors"
                            >
                                Endast nödvändiga
                            </button>
                            <button
                                onClick={handleAcceptAll}
                                className="px-6 py-2.5 text-sm font-semibold text-white bg-slate-900 hover:bg-slate-800 rounded-xl shadow-lg transition-all hover:scale-105"
                            >
                                Acceptera alla
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieBanner;
